import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { SVGFC } from '@repo/toolkit/types'

const DownArrowIcon: SVGFC = ({ color = tailwindColors.red.DEFAULT, ...props }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_19487_55940)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.99968 10.5002C7.32185 10.5002 7.58301 10.2391 7.58301 9.91691L7.58301 1.99162L8.92053 3.32914C9.14834 3.55693 9.51768 3.55693 9.74549 3.32914C9.97329 3.10135 9.97329 2.73198 9.74549 2.50419L7.41215 0.170859C7.30278 0.061484 7.15438 5.86244e-07 6.99968 5.79482e-07C6.84498 5.7272e-07 6.69658 0.0614839 6.5872 0.170859L4.25387 2.50419C4.02608 2.73198 4.02608 3.10135 4.25387 3.32914C4.48166 3.55693 4.85103 3.55693 5.07882 3.32914L6.41634 1.99162L6.41634 9.91691C6.41634 10.2391 6.6775 10.5002 6.99968 10.5002ZM12.833 13.4167C12.833 13.0945 12.5718 12.8333 12.2497 12.8333L1.74967 12.8333C1.4275 12.8333 1.16634 13.0945 1.16634 13.4167C1.16634 13.7388 1.4275 14 1.74967 14L12.2497 14C12.5718 14 12.833 13.7388 12.833 13.4167Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_19487_55940">
          <rect width="14" height="14" fill="white" transform="translate(14 14) rotate(-180)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default DownArrowIcon
